import { useModel as _useModel, useCssVars as _useCssVars, unref as _unref, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "row justify-center items-center fit" }
const _hoisted_2 = { class: "fs-13px fw-500" }

import type { StyleValue } from 'vue'

interface ITab {
  name: string
  label: string
  class?: string
  disable?: boolean
  icon?: string
  attrs?: Record<PropertyKey, unknown>
}

interface IProps {
  tabs: ITab[]
  separator?: boolean
  rootStyle?: StyleValue
  color?: string
  activeColor?: string
  bgColor?: string
  activeBgColor?: string
  hoverColor?: string
  hoverBgColor?: string
  separatorColor?: string
  tabBoxStyle?: StyleValue
  tabBorderRadius?: string
  containerBorderRadius?: string
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KTab' },
  __name: 'KTab',
  props: /*@__PURE__*/_mergeModels({
    tabs: {},
    separator: { type: Boolean, default: true },
    rootStyle: { type: [Boolean, null, String, Object, Array], default: '' },
    color: { default: 'var(--cool-gray-70)' },
    activeColor: { default: 'var(--cool-gray-100)' },
    bgColor: { default: 'var(--cool-gray-30)' },
    activeBgColor: { default: 'var(--white)' },
    hoverColor: { default: 'var(--space-b-70)' },
    hoverBgColor: { default: 'var(--space-b-10)' },
    separatorColor: { default: 'var(--cool-gray-40)' },
    tabBoxStyle: { type: [Boolean, null, String, Object, Array], default: '' },
    tabBorderRadius: { default: '8px' },
    containerBorderRadius: { default: '12px' }
  }, {
    "modelValue": { required: true },
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(['update:modelValue'], ["update:modelValue"]),
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v299d0db3": (_ctx.bgColor),
  "c4e5ef90": (_ctx.color),
  "v86911c58": (_ctx.containerBorderRadius),
  "e8d62ab0": (_ctx.tabBorderRadius),
  "v5d7c5912": (_ctx.activeColor),
  "bfef805c": (_ctx.hoverColor),
  "aa08dfe6": (_ctx.activeBgColor),
  "v6c32ab6e": (_ctx.separatorColor),
  "v7a28c6cd": (_ctx.hoverBgColor)
}))




const model = _useModel<string>(__props, "modelValue")

return (_ctx: any,_cache: any) => {
  const _component_k_icon = _resolveComponent("k-icon")!
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!

  return (_openBlock(), _createElementBlock("div", {
    class: "full-width",
    style: _normalizeStyle(__props.rootStyle)
  }, [
    _renderSlot(_ctx.$slots, "before"),
    _createVNode(_component_q_tabs, _mergeProps({
      modelValue: model.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
      class: "k-tab-container full-width",
      align: "justify",
      "indicator-color": "transparent",
      "active-class": "active-tab",
      "inline-label": "",
      "no-caps": ""
    }, _ctx.$attrs), {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "prepend"),
        _renderSlot(_ctx.$slots, "default", {}, () => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab, index) => {
            return (_openBlock(), _createElementBlock("span", {
              key: index,
              class: "k-tab-box",
              style: _normalizeStyle(__props.tabBoxStyle)
            }, [
              _renderSlot(_ctx.$slots, "before-tab", { index: index }),
              _createVNode(_component_q_tab, _mergeProps({
                class: { 'k-tab': !tab.class, 'tab-separator': __props.separator },
                name: tab.name,
                disable: Boolean(tab.disable || _ctx.$attrs['disable'])
              }, { ref_for: true }, tab.attrs), {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "tab-content", {
                    tab: tab,
                    index: index
                  }, () => [
                    _createElementVNode("div", _hoisted_1, [
                      (tab.icon)
                        ? (_openBlock(), _createBlock(_component_k_icon, {
                            key: 0,
                            class: "k-tab-icon q-mr-sm",
                            name: tab.icon,
                            size: "24px"
                          }, null, 8, ["name"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_2, _toDisplayString(tab.label), 1)
                    ])
                  ])
                ]),
                _: 2
              }, 1040, ["class", "name", "disable"]),
              _renderSlot(_ctx.$slots, "after-tab", { index: index })
            ], 4))
          }), 128))
        ]),
        _renderSlot(_ctx.$slots, "append")
      ]),
      _: 3
    }, 16, ["modelValue"]),
    _renderSlot(_ctx.$slots, "after")
  ], 4))
}
}

})